import { InProductTrialsOverlayWindowsAppBaseDataProvider } from './InProductTrialsOverlayWindowsAppBaseDataProvider';
import { InProductTrialsAdditionalUserSettings } from '../types/InProductTrialsAdditionalUserSettings';

export class InProductTrialsOverlayWindowsAppGzDataProvider extends InProductTrialsOverlayWindowsAppBaseDataProvider {
  public async getAdditionalUserSettingsForInProductTrials(): Promise<InProductTrialsAdditionalUserSettings> {
    const record =
      await this.dependencies.api.clients.AdditionalUserSettings.GetAdditionalUserSettingsForInProductTrials().toPromise();

    if (!record) {
      throw new Error('No data for additional user settings.');
    }

    return record;
  }
}
